export enum TextFieldType {
  DEFAULT = 'DEFAULT',
  HIGHLIGHT = 'HIGHLIGHT',
  INPUT_BUTTON = 'INPUT_BUTTON',
  SIMPLE = 'SIMPLE'
}
